import List from './List'
import ListItem from './ListItem'
import ListTitle from './ListTitle'

List.Item =  ListItem
List.Title =  ListTitle

export default List